import * as ko from 'knockout'
import ObservableResultsPage from '@classic/Betting-v2/Model/Observables/ObservableResultsPage'
import resultsViewTemplate from './results.view.tpl.html'
import fieldViewTemplate from './results.field.view.tpl.html'
import { ResultsViewModel } from './ResultsViewModel'
import { ResultsFieldViewModel } from './ResultsFieldViewModel'

if (!ko.components.isRegistered('results-view')) {
  ko.components.register('results-view', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableResultsPage }) => {
        const viewModel = new ResultsViewModel(params)
        return viewModel
      },
    },
    template: resultsViewTemplate,
  })
}
if (!ko.components.isRegistered('results-field-view')) {
  ko.components.register('results-field-view', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableResultsPage }) => {
        const viewModel = new ResultsFieldViewModel(params)
        return viewModel
      },
    },
    template: fieldViewTemplate,
  })
}
